import { InvoiceStateEnum } from '../models/InvoiceModel';
import axios from 'axios';
import { InvoiceModel } from '../models/InvoiceModel';
import { AmountCreditNoteRequestModel } from '../models/AmountCreditNoteRequestModel';

const API_URL = process.env.REACT_APP_API_URL;
const INVOICES_URL = `${API_URL}/api/b2b/invoices/`;
const AMOUNT_INVOICES_URL = `${API_URL}/api/b2b/invoices/invoice-amount/`;
export const INVOICES_PER_PAGE = 20;

interface ListInvoicesResponse {
  results: Array<InvoiceModel>;
  count: number;
}

interface ListInvoicesProps {
  distributor: number;
  page: number;
  state: InvoiceStateEnum | null;
  is_proforma: boolean | null;
  is_credit: boolean | null;
  is_manual: boolean | null;
  note_code: string | null;
  order_code: string | null;
  external_ref: string | null;
  accounted: boolean | null;
  date__gte?: string;
  date__lte?: string;
}

export function listInvoices({
  distributor,
  page = 1,
  state = null,
  is_proforma = null,
  is_credit = null,
  is_manual = null,
  note_code = null,
  order_code = null,
  external_ref = null,
  accounted = null,
  date__gte,
  date__lte,
}: ListInvoicesProps): Promise<{ data: ListInvoicesResponse }> {
  return axios.get(INVOICES_URL, {
    params: {
      distributor,
      offset: (page - 1) * INVOICES_PER_PAGE,
      limit: INVOICES_PER_PAGE,
      state,
      is_proforma,
      is_credit,
      is_manual,
      note_code,
      order_code,
      external_ref,
      accounted,
      date__gte,
      date__lte,
    },
  });
}

export function getInvoiceById(id: number): Promise<{ data: InvoiceModel }> {
  const endpoint = `${INVOICES_URL}${id}/`;
  return axios.get(endpoint);
}

export function createInvoice({ orderId, date, isProforma = false }) {
  return axios.post(INVOICES_URL, {
    order: orderId,
    date,
    is_proforma: isProforma,
    is_credit: false,
  });
}

export function updateInvoice(invoice: InvoiceModel) {
  const endpoint = `${INVOICES_URL}${invoice.id}/`;
  return axios.patch(endpoint, { ...invoice });
}

export function generateEdiFile(invoiceId: number) {
  const endpoint = `${INVOICES_URL}${invoiceId}/generate-edi-file/`;
  return axios.post(endpoint);
}

export function uploadEdiFile(invoiceId: number) {
  const endpoint = `${INVOICES_URL}${invoiceId}/upload-edi-file/`;
  return axios.post(endpoint);
}

export function generatePdfFile(invoiceId: number) {
  const endpoint = `${INVOICES_URL}${invoiceId}/generate-pdf/`;
  return axios.post(endpoint);
}

export interface UpdateInvoiceNumberProps {
  next_num: number;
  is_credit: boolean;
  is_proforma: boolean;
}
export function updateInvoiceNumber({
  next_num,
  is_credit,
  is_proforma,
}: UpdateInvoiceNumberProps) {
  const endpoint = `${INVOICES_URL}invoice-number/`;
  return axios.patch(endpoint, { next_num, is_credit, is_proforma });
}

export function createInvoicePreview({ orderId }) {
  const endpoint = INVOICES_URL;

  return axios.post(endpoint, {
    order: orderId,
    is_preview: true,
  });
}

export function confirmInvoicePreview({ invoiceId }) {
  const endpoint = `${INVOICES_URL}invoice-preview-decision/`;

  return axios.post(endpoint, {
    invoice: invoiceId,
    accept: true,
  });
}

export function discardInvoicePreview({ invoiceId }) {
  const endpoint = `${INVOICES_URL}invoice-preview-decision/`;

  return axios.post(endpoint, {
    invoice: invoiceId,
    accept: false,
  });
}

export function createAmountInvoice(
  amountInvoiceRequest: AmountCreditNoteRequestModel
): Promise<{ data: InvoiceModel }> {
  return axios.post(AMOUNT_INVOICES_URL, amountInvoiceRequest);
}

export enum BulkActionsEnum {
  EXPORT_INVOICES = 'export_invoices',
}

export function performBulkAction({
  invoiceIds,
  action,
  distributor,
  state,
  is_proforma,
  is_credit,
  is_manual,
  note_code,
  order_code,
  external_ref,
  accounted,
  date__gte,
  date__lte,
  responseType = 'json',
}: {
  invoiceIds: Array<number>;
  action: BulkActionsEnum;
  distributor?: number | null;
  state?: InvoiceStateEnum | null;
  is_proforma?: boolean | null;
  is_credit?: boolean | null;
  is_manual?: boolean | null;
  note_code?: string | null;
  order_code?: string | null;
  external_ref?: string | null;
  accounted?: boolean | null;
  date__gte?: string;
  date__lte?: string;
  responseType?: 'blob' | 'json';
}) {
  const payload: Record<string, unknown> = {
    action,
  };
  if (invoiceIds?.length > 0) payload.invoices = invoiceIds;
  if (distributor != null) payload.distributor = distributor;
  if (state != null) payload.state = state;
  if (is_proforma != null) payload.is_proforma = is_proforma;
  if (is_credit != null) payload.is_credit = is_credit;
  if (is_manual != null) payload.is_manual = is_manual;
  if (note_code != null) payload.note_code = note_code;
  if (order_code != null) payload.order_code = order_code;
  if (external_ref != null) payload.external_ref = external_ref;
  if (accounted != null) payload.accounted = accounted;
  if (date__gte != null) payload.date__gte = date__gte;
  if (date__lte != null) payload.date__lte = date__lte;

  return axios.post(`${INVOICES_URL}massive-actions/`, payload, {
    responseType,
  });
}
